const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgba(237, 108, 2, 1)",
      fillOpacity: 1
    },
    d: "M 0.0195312 10.285156 L 3.199219 12.421875 L 0.980469 6.164062 L 4.308594 9.441406 L 3.886719 1.804688 L 7.996094 7.878906 L 8.382812 4 L 9.585938 7.367188 L 11.683594 0 L 11.832031 8.300781 L 13.691406 6.164062 L 13.453125 9.082031 L 17.980469 4.722656 L 14.953125 13.714844 L 17.917969 12.691406 L 15.972656 16 L 12.714844 16 L 13.363281 12.445312 L 10.96875 14.761719 L 10.601562 12.191406 L 10.148438 13.613281 L 9.300781 12.035156 L 9.128906 13.71875 L 7.140625 11.226562 L 7.175781 15.007812 L 5.445312 13.582031 L 5.65625 16 L 2.722656 16 Z M 0.0195312 10.285156 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeSafety);
export default __webpack_public_path__ + "static/media/employeeSafety.b339a88fc8a7a6347b2f1372568ab40c.svg";
export { ForwardRef as ReactComponent };